<section class="bmc-tableau">
  <div class="bmc-tableau__header">
    <p>{{'TABLEAU.DESCRIPTION' | translate}}</p>
  </div>
  <div class="bmc-tableau__tree-main">
    <div class="bmc-tableau__tree-panel" id="panel-tree">
      <div class="tree-container">
        <h5 class="bz-font-weight--semibold">{{ 'TABLEAU.CONFIG_TITLE' | translate }}</h5>
        <div *ngIf="tableauConfigurations">
          <div class="bmc-tree-node" *ngFor="let configuration of tableauConfigurations">
            <div class="bmc-tree-node__item bmc-flex" [class.selected]="isSelected(configuration.Id)">
              <div (click)="collapseItems(isOpen(configuration.Id), configuration.Id)" style="display: inline-block;">
                <svg class="bmc-tree-node__arrow" *ngIf="configuration.reports.length > 0">
                  <use *ngIf="!isOpen(configuration.Id)" href="#icon-arrow-right-bold"></use>
                  <use *ngIf="isOpen(configuration.Id)" href="#icon-arrow-down-bold"></use>
                </svg>
              </div>
              <span (click)="clickItem(configuration)"
                class="bmc-tree-node__text bmc-display-block">{{configuration.DisplayName}}</span>
            </div>

            <div *ngIf="isOpen(configuration.Id)">
              <div *ngFor="let reportConf of configuration.reports">
                <div (click)="clickItemReport(reportConf)" class="bmc-tree-node__item bmc-tree-node__margin-left"
                  [class.selected]="isSelected(reportConf.Id)">
                  {{reportConf.DisplayName}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bmc-tableau__tree-detail">
      <div class="bmc-tableau__placeholder" *ngIf="tableauConfigurations.length > 0 && !anyItemSelected && !isLoading">
        <p class="bmc-tableau__placeholder__text">{{'TABLEAU.SELECT_COMPONENT' | translate}}</p>
      </div>
      <div *ngIf="isLoading" class="bz-env-loading">
        <bounce>{{ 'GLOBAL.LOADING_DATA' | translate }}</bounce>
      </div>
      <div *ngIf="(tableauConfigurations.length === 0 || !tableauConfigurations) && !isLoading">
        <div class="bmc-tableau__image">
          <img src="assets/img/bz-not-found.png">
          <p>{{ 'TABLEAU.WHITHOUT_COMPONENTS' | translate }}</p>
        </div>
      </div>
      <div *ngIf="tableauConfigurations.length > 0 && anyItemSelected && !isLoading" class="container">
        <dv-tableau-detail [tableauConfiguration]="tableauConfiguration" [reportConfiguration]="reportConfiguration" [isConexion]="isConexion" (updateTable)="updateTable()">
        </dv-tableau-detail>
      </div>
    </div>
  </div>
</section>